import { FaAward } from "react-icons/fa6";
import { TbBooks } from "react-icons/tb";
import { BiHappyHeartEyes } from "react-icons/bi";

const data = [
    {id:1,icon:<FaAward />,title:'Experience',desc:'Studying'},
    {id:2,icon:<TbBooks />,title:'Projects',desc:'3+ completed'},
    {id:3,icon:<BiHappyHeartEyes />,title:'Happy clients',desc:'1+ happy clients'},
]

export default data;

